import {withFormik} from "formik";
import compose from "recompose/compose";
import withProps from "recompose/withProps";

import QrValueMap from "@xem/qr-common/classes/QrValueMap";
import withStyle from '@xem/qr-client-react/helpers/popup/qrcode/render/Style';
import withFrameOptions from "../helpers/popup/qrcode/render/Form.options";
import getQrcodeData from '../helpers/getQrcodeData';
import withPreOptions from "./Vietbank.options";
import vietbankStyle from "./Vietbank.style";
import utilsCompose, { endCompose } from "../helpers/popup/qrcode/utils";
import * as Yup from "yup";


const mapPropsToValues = function mapPropsToValues({ data }: any){
	let content = data?.content;
	let on = content?.on || 1;
	let amount = content?.amount || 0;
	let bankBin = content?.bankBin || null;
	let bankNumber = content?.bankNumber || '';
	let purpose = content?.purpose || '';
	let bankNameAccount = content?.bankNameAccount || '';
	return ({ ...QrValueMap(content?.qrcode), content:{ on, bankNumber, bankBin, bankNameAccount, amount, purpose } })
}

function getOptions() {
	let options = [];
	[...withPreOptions].forEach((v: any)=>options.push(v));
	[...withFrameOptions].forEach((v: any)=>options.push(v));
	return options;
}

/**
 *
 */
export const DataForm = withFormik({
	enableReinitialize: true,
	displayName: `QrCode`,
	mapPropsToValues,
	validationSchema: ({ value = 5 }) =>
		Yup.object().shape({
			content: Yup.object().shape({
				bankBin: Yup.string().nullable().required('Bank is required'.t()),
				bankNumber: Yup.string().required('Bank number is required'.t())
			})
		}),
	handleSubmit: function handleSubmit(){},
});

export default compose(
	withStyle,
	vietbankStyle,
	withProps({ frameOptions: getOptions() }),
	utilsCompose,
	DataForm,
	withProps(({ tabDefault, errors, setFieldValue, handleSubmit, values })=>
		({
			errors: { ...errors, info: errors.content},
			tabDefault: tabDefault || 'info',
			data_text: getQrcodeData(values?.content),
			setDefault: function(){ setFieldValue('qr_default', true); handleSubmit(); }
		})),
	endCompose(),
	// withProps(({ errors })=>debug({ errors })),
	// withProps(({ values })=> debug({ values })),
);